import ReferrerFields from 'routes/ReferralForm/ReferrerFields/ReferrerFields';

export default ReferrerFields;
